import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from '@/auth/utils';
import { canNavigate } from '@/libs/acl/routeProtection';
import mainData from './routes/mainData';
import transactions from './routes/transactions';
import salesTransactions from './routes/salesTransactions';
import purchTransactions from './routes/purchTransactions';

const HASBA_HIDDEN_ROUTES = [
  'agent-itineraries-status',
  'dealersClassification',
  'add-dealers-classification',
  'edit-dealer-classification',
  'agentItinerary',
  'purchOrder',
  'purchOrder-edit',
  'manufacturing-order-new',
  'manufacturing-order-edit',
  'account-groups',
  'bulk-invoices',
  'logs',
];

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...mainData,
    ...transactions,
    ...salesTransactions,
    ...purchTransactions,
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/Dashboard/Home/EditFiscal.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/restaurant-dashboard',
      name: 'restaurantDashboard',
      component: () => import('@/pages/Dashboard/RestaurantDashboard.vue'),
      meta: {
        pageTitle: 'restaurantDashboard',
        breadcrumb: [
          {
            text: 'restaurantDashboard',
            active: true,
          },
        ],
        permission: 'viewRestaurantDashboard',
      },
    },
    {
      path: '/branches-dashboard',
      name: 'branchesDashboard',
      component: () => import('@/pages/Dashboard/BranchesDashboard.vue'),
      meta: {
        pageTitle: 'branchesDashboard',
        breadcrumb: [
          {
            text: 'branchesDashboard',
            active: true,
          },
        ],
        permission: 'viewBranchesDashboard',
      },
    },
    {
      path: '/usersAndAgents-dashboard',
      name: 'usersAndAgentsDashboard',
      component: () => import('@/pages/Dashboard/UsersAndAgentsDashboard.vue'),
      meta: {
        pageTitle: 'usersAndAgentsDashboard',
        breadcrumb: [
          {
            text: 'usersAndAgentsDashboard',
            active: true,
          },
        ],
        permission: 'viewUsersAndAgentsDashboard',
      },
    },
    {
      path: '/concrete-dashboard',
      name: 'concreteDashboard',
      component: () => import('@/pages/Dashboard/ConcreteDashboard/Edit.vue'),
      meta: {
        pageTitle: 'concreteDashboard',
        breadcrumb: [
          {
            text: 'concreteDashboard',
            active: true,
          },
        ],
        permission: 'viewConcreteDashboard',
      },
    },
    {
      path: '/agentItinerary',
      name: 'agentItinerary',
      component: () => import('@/pages/Dealers/calendar/Edit.vue'),
      meta: {
        pageTitle: 'agentItinerary',
        breadcrumb: [{ text: 'dealers', active: true }],
        permission: 'viewAgentItinerary',
      },
    },
    {
      path: '/cementTypes',
      name: 'cementTypes',
      component: () => import('@/pages/MainData/CementTypes/List.vue'),
      meta: {
        pageTitle: 'cementTypes',
        breadcrumb: [{ text: 'mainData', active: true }],
        permission: 'viewCementTypes',
      },
    },
    {
      path: '/castingTypes',
      name: 'castingTypes',
      component: () => import('@/pages/MainData/CastingTypes/List.vue'),
      meta: {
        pageTitle: 'castingTypes',
        breadcrumb: [{ text: 'mainData', active: true }],
        permission: 'viewCastingTypes',
      },
    },
    {
      path: '/maxTemperature',
      name: 'maxTemperature',
      component: () => import('@/pages/MainData/MaxTemperature/List.vue'),
      meta: {
        pageTitle: 'maxTemperature',
        breadcrumb: [{ text: 'mainData', active: true }],
        permission: 'viewMaxTemperature',
      },
    },
    {
      path: '/subscription-data',
      name: 'subscriptionData',
      component: () => import('@/pages/SubscriptionData/Edit.vue'),
      meta: {
        pageTitle: 'subscriptionData',
        breadcrumb: [
          {
            text: 'subscriptionData',
            active: true,
          },
        ],
      },
    },
    {
      path: '/posConfigurations',
      name: 'posConfigurations',
      component: () => import('@/pages/Settings/posConfigurations/Edit.vue'),
      meta: {
        pageTitle: 'posConfigurations',
        breadcrumb: [
          {
            text: 'posConfigurations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/snaPos-payment-methods',
      name: 'snaPos-payment-methods',
      component: () => import('@/pages/Settings/SnaPos/PaymentMethods.vue'),
      meta: {
        pageTitle: 'snaPosPaymentMethods',
        breadcrumb: [
          {
            text: 'snaPosPaymentMethods',
            active: true,
          },
        ],
      },
    },
    {
      path: '/actions',
      name: 'actions',
      component: () => import('@/pages/Settings/Actions/Edit.vue'),
      meta: {
        pageTitle: 'actions',
        breadcrumb: [
          {
            text: 'actions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/agents',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'agents',
          component: () => import('@/pages/Dealers/Agents/List.vue'),
          meta: {
            pageTitle: 'agents',
            breadcrumb: [{ text: 'dealers', active: true }],
            permission: 'viewAgents',
          },
        },
        {
          path: 'new',
          name: 'new-agent',
          component: () => import('@/pages/Dealers/Agents/Edit.vue'),
          meta: {
            pageTitle: 'newAgent',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'agents', active: true },
            ],
            permission: 'addAgents',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-agents',
          props: true,
          component: () => import('@/pages/Dealers/Agents/Edit.vue'),
          meta: {
            pageTitle: 'editAgent',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'agents', active: true },
            ],
            permission: 'editAgents',
          },
        },
      ],
    },
    {
      path: '/warehouses',
      name: 'warehouses',
      component: () => import('@/pages/Stores/warehouses/List.vue'),
      meta: {
        pageTitle: 'warehouses',
        breadcrumb: [{ text: 'Stores', active: true }],
        permission: 'viewStores',
      },
    },
    {
      path: '/items-category',
      name: 'items-category',
      component: () => import('@/pages/Items/itemCategory/List.vue'),
      meta: {
        pageTitle: 'itemsCategory',
        breadcrumb: [{ text: 'Items', active: true }],
        permission: 'viewItemCategories',
      },
    },
    {
      path: '/units',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'units',
          component: () => import('@/pages/Items/units/List.vue'),
          meta: {
            pageTitle: 'Units',
            breadcrumb: [{ text: 'Items', active: true }],
            permission: 'viewUnits',
          },
        },
        {
          path: 'new',
          name: 'new-units',
          component: () => import('@/pages/Items/units/Edit.vue'),
          meta: {
            pageTitle: 'New Unit',
            breadcrumb: [
              { text: 'Items', active: true },
              { text: 'Units', active: true },
            ],
            permission: 'addUnits',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-units',
          props: true,
          component: () => import('@/pages/Items/units/Edit.vue'),
          meta: {
            pageTitle: 'Edit Unit',
            breadcrumb: [
              { text: 'Items', active: true },
              { text: 'Units', active: true },
            ],
            permission: 'editUnits',
          },
        },
      ],
    },
    {
      path: '/taxs',
      name: 'taxs',
      component: () => import('@/pages/Settings/taxs/List.vue'),
      meta: {
        pageTitle: 'taxs',
        breadcrumb: [{ text: 'Settings', active: true }],
        permission: 'viewTaxTypes',
      },
    },
    // {
    //   path: '/taxs-config',
    //   name: 'taxs-config',
    //   component: () => import('@/pages/Settings/taxsconfig/List.vue'),
    //   meta: {
    //     pageTitle: 'taxsConfig',
    //     breadcrumb: [{ text: 'Settings', active: true }],
    //     permission: 'viewTaxLinks',
    //   },
    // },
    {
      path: '/users',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'users',
          component: () => import('@/pages/Settings/Users/List.vue'),
          meta: {
            pageTitle: 'users',
            breadcrumb: [{ text: 'Settings', active: true }],
            permission: 'viewUsers',
          },
        },
        {
          path: 'new',
          name: 'new-users',
          component: () => import('@/pages/Settings/Users/Edit.vue'),
          meta: {
            pageTitle: 'newUser',
            breadcrumb: [
              { text: 'Settings', active: true },
              { text: 'users', active: true },
            ],
            permission: 'addUsers',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-users',
          props: true,
          component: () => import('@/pages/Settings/Users/Edit.vue'),
          meta: {
            pageTitle: 'editUser',
            breadcrumb: [
              { text: 'Settings', active: true },
              { text: 'users', active: true },
            ],
            permission: 'editUsers',
          },
        },
      ],
    },
    {
      path: '/customers',
      component: () => import('@/layouts/navigationIndex.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'customers',
          component: () => import('@/pages/Dealers/Customers/List.vue'),
          meta: {
            pageTitle: 'customers',
            breadcrumb: [{ text: 'dealers', active: true }],
            permission: 'viewCustomers',
          },
        },
        {
          path: 'new',
          name: 'add-customer',
          component: () => import('@/pages/Dealers/Customers/Edit.vue'),
          meta: {
            pageTitle: 'addNewCustomer',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'customers', active: true },
            ],
            permission: 'addCustomers',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-customer',
          component: () => import('@/pages/Dealers/Customers/Edit.vue'),
          props: true,
          meta: {
            pageTitle: 'customer-edit',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'customers', active: true },
            ],
            permission: 'editCustomers',
          },
        },
      ],
    },

    {
      path: '/dealersClassification',
      component: () => import('@/layouts/navigationIndex.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'dealersClassification',
          component: () => import('@/pages/Dealers/DealersClassification/List.vue'),
          meta: {
            pageTitle: 'dealersClassification',
            breadcrumb: [{ text: 'dealers', active: true }],
            permission: 'viewDealersClassification',
          },
        },
        {
          path: 'new',
          name: 'add-dealers-classification',
          component: () => import('@/pages/Dealers/DealersClassification/Edit.vue'),
          meta: {
            pageTitle: 'addNewDealersClassification',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'dealersClassification', active: true },
            ],
            permission: 'addDealersClassification',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-dealer-classification',
          component: () => import('@/pages/Dealers/DealersClassification/Edit.vue'),
          props: true,
          meta: {
            pageTitle: 'editDealersClassification',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'dealersClassification', active: true },
            ],
            permission: 'editDealersClassification',
          },
        },
      ],
    },
    {
      path: '/mediatorSystem',
      component: () => import('@/layouts/navigationIndex.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'mediatorSystem',
          component: () => import('@/pages/Dealers/MediatorSystem/List.vue'),
          meta: {
            pageTitle: 'mediatorSystem',
            breadcrumb: [{ text: 'dealers', active: true }],
            permission: 'viewMediatorSystem',
          },
        },
        {
          path: 'new',
          name: 'add-mediator-system',
          component: () => import('@/pages/Dealers/MediatorSystem/Edit.vue'),
          meta: {
            pageTitle: 'addNewMediatorSystem',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'mediatorSystem', active: true },
            ],
            permission: 'useMediatorSystem',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-mediator-system',
          component: () => import('@/pages/Dealers/MediatorSystem/Edit.vue'),
          props: true,
          meta: {
            pageTitle: 'editMediatorSystem',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'mediatorSystem', active: true },
            ],
            permission: 'editMediatorSystem',
          },
        },
      ],
    },
    {
      path: '/mainDealer',
      component: () => import('@/layouts/navigationIndex.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'mainDealer',
          component: () => import('@/pages/Dealers/MainDealer/List.vue'),
          meta: {
            pageTitle: 'mainDealer',
            breadcrumb: [{ text: 'dealers', active: true }],
            permission: 'viewMainDealer',
          },
        },
        {
          path: 'new',
          name: 'add-main-dealer',
          component: () => import('@/pages/Dealers/MainDealer/Edit.vue'),
          meta: {
            pageTitle: 'addNewMainDealer',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'mainDealer', active: true },
            ],
            permission: 'addMainDealer',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-main-dealer',
          component: () => import('@/pages/Dealers/MainDealer/Edit.vue'),
          props: true,
          meta: {
            pageTitle: 'editMainDealer',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'mainDealer', active: true },
            ],
            permission: 'editMainDealer',
          },
        },
      ],
    },
    {
      path: '/company',
      name: 'company',
      component: () => import('@/pages/Settings/company/Edit.vue'),
      meta: {
        pageTitle: 'company',
        breadcrumb: [{ text: 'Settings', active: true }],
        permission: 'editCompany',
      },
    },
    {
      path: '/loyalty-points',
      name: 'loyalty-points',
      component: () => import('@/pages/Settings/LoyaltyPoints/Edit.vue'),
      meta: {
        pageTitle: 'loyaltyPointsSetting',
        breadcrumb: [{ text: 'Settings', active: true }],
        permission: 'editCompany',
      },
    },
    {
      path: '/support-tickets',
      name: 'support-tickets',
      component: () => import('@/pages/Settings/supportTickets/List.vue'),
      meta: {
        pageTitle: 'supportTickets',
        breadcrumb: [{ text: 'Settings', active: true }],
        permission: '',
      },
    },
    {
      path: '/restaurant-orders',
      name: 'restaurant-orders',
      component: () => import('@/pages/Sales/Orders/OrdersEntry.vue'),
      meta: {
        pageTitle: 'restaurantOrders',
        breadcrumb: [
          {
            text: 'sales',
            active: true,
          },
        ],
        permission: 'viewKitchenOrders'
      },
    },
    {
      path: '/branches',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'branches',
          component: () => import('@/pages/Settings/branches/List.vue'),
          meta: {
            pageTitle: 'Branches',
            breadcrumb: [{ text: 'Settings', active: true }],
            permission: 'viewBranches',
          },
        },
        {
          path: 'new',
          name: 'branch-new',
          component: () => import('@/pages/Settings/branches/Edit.vue'),
          meta: {
            pageTitle: 'branchNew',
            breadcrumb: [
              { text: 'Settings', active: true },
              { text: 'Branches', active: true },
            ],
            permission: 'addBranches',
          },
        },
        {
          path: 'edit/:id',
          name: 'branch-edit',
          props: true,
          component: () => import('@/pages/Settings/branches/Edit.vue'),
          meta: {
            pageTitle: 'branchEdit',
            breadcrumb: [
              { text: 'Settings', active: true },
              { text: 'Branches', active: true },
            ],
            permission: 'editBranches',
          },
        },
        {
          path: 'startUp/:id',
          name: 'startUp-branch-edit',
          props: true,
          component: () => import('@/pages/Settings/branches/Edit.vue'),
          meta: {
            layout: 'full',
            pageTitle: 'startUp',
            breadcrumb: [
              { text: 'Settings', active: true },
              { text: 'Branches', active: true },
            ],
            permission: 'editBranches',
          },
        },
      ],
    },
    {
      path: '/suppliers',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'suppliers',
          component: () => import('@/pages/Dealers/Suppliers/List.vue'),
          meta: {
            pageTitle: 'suppliers',
            breadcrumb: [{ text: 'dealers', active: true }],
            permission: 'viewSuppliers',
          },
        },
        {
          path: 'new',
          name: 'add-supplier',
          component: () => import('@/pages/Dealers/Suppliers/Edit.vue'),
          meta: {
            pageTitle: 'addNewSupplier',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'suppliers', active: true },
            ],
            permission: 'addSuppliers',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-supplier',
          props: true,
          component: () => import('@/pages/Dealers/Suppliers/Edit.vue'),
          meta: {
            pageTitle: 'supplierEdit',
            breadcrumb: [
              { text: 'dealers', active: true },
              { text: 'suppliers', active: true },
            ],
            permission: 'editSuppliers',
          },
        },
      ],
    },
    {
      path: '/price-list',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'priceLists',
          component: () => import('@/pages/Items/PriceList/List.vue'),
          meta: {
            pageTitle: 'priceLists',
            breadcrumb: [{ text: 'items', active: true }],
            permission: 'viewPriceLists',
          },
        },
        {
          path: 'new',
          name: 'add-priceList',
          component: () => import('@/pages/Items/PriceList/Edit.vue'),
          meta: {
            pageTitle: 'addNewPriceList',
            breadcrumb: [
              { text: 'items', active: true },
              { text: 'priceList', active: true },
            ],
            permission: 'addPriceLists',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-priceList',
          props: true,
          component: () => import('@/pages/Items/PriceList/Edit.vue'),
          meta: {
            pageTitle: 'editPriceList',
            breadcrumb: [
              { text: 'items', active: true },
              { text: 'priceList', active: true },
            ],
            permission: 'editPriceLists',
          },
        },
      ],
    },
    {
      path: '/Items',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'items',
          component: () => import('@/pages/Items/items/List.vue'),
          meta: {
            pageTitle: 'items',
            breadcrumb: [{ text: 'items', active: true }],
            permission: 'viewItems',
          },
        },
        {
          path: 'new',
          name: 'add-item',
          component: () => import('@/pages/Items/items/Edit.vue'),
          meta: {
            pageTitle: 'addNewItem',
            breadcrumb: [
              { text: 'items', active: true },
              { text: 'listItems', active: true },
            ],
            permission: 'addItems',
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-item',
          props: true,
          component: () => import('@/pages/Items/items/Edit.vue'),
          meta: {
            pageTitle: 'editItems',
            breadcrumb: [
              { text: 'items', active: true },
              { text: 'listItems', active: true },
            ],
            permission: 'editItems',
          },
        },
      ],
    },
    {
      path: '/chart-of-account',
      name: 'chartOfAccount',
      component: () => import('@/pages/Accounts/chartOfAccount/List.vue'),
      meta: {
        pageTitle: 'chartOfAccount',
        breadcrumb: [{ text: 'accounts', active: true }],
        permission: 'viewAccounts',
      },
    },
    {
      path: '/cost-center',
      name: 'costCenter',
      component: () => import('@/pages/Accounts/costCenter/List.vue'),
      meta: {
        pageTitle: 'costCenter',
        breadcrumb: [{ text: 'accounts', active: true }],
        permission: 'viewCostCenters',
      },
    },
    {
      path: '/post-vouchers',
      name: 'post-vouchers',
      component: () => import('@/pages/Accounts/vouchers/PostVouchers.vue'),
      meta: {
        pageTitle: 'postVouchers',
        breadcrumb: [
          {
            text: 'accounts',
            active: true,
          },
        ],
        permission: 'gLPost',
      },
    },
    {
      path: '/bulk-invoices',
      name: 'bulk-invoices',
      component: () => import('@/pages/Accounts/BulkInvoices/Edit.vue'),
      meta: {
        pageTitle: 'bulkInvoices',
        breadcrumb: [
          {
            text: 'accounts',
            active: true,
          },
        ],
        permission: '',
      },
    },
    {
      path: '/sendInvoiceToZatca',
      name: 'sendInvoiceToZatca',
      component: () => import('@/pages/Accounts/vouchers/ZatcaPostVouchers.vue'),
      meta: {
        pageTitle: 'sendInvoiceToZatca',
        breadcrumb: [
          {
            text: 'accounts',
            active: true,
          },
        ],
        permission: 'sendInvoiceToZatca',
      },
    },
    {
      path: '/vouchers',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'vouchers',
          component: () => import('@/pages/Accounts/vouchers/List.vue'),
          meta: {
            pageTitle: 'vouchers',
            breadcrumb: [{ text: 'accounts', active: true }],
            permission: 'viewVouchers',
          },
        },
        {
          path: 'new',
          name: 'vouchers-new',
          component: () => import('@/pages/Accounts/vouchers/Edit.vue'),
          meta: {
            pageTitle: 'vouchersNew',
            breadcrumb: [
              { text: 'accounts', active: true },
              { text: 'vouchers', active: true },
            ],
            permission: 'addVouchers',
          },
        },
        {
          path: 'closedVoucher',
          name: 'closedVoucher-new',
          component: () => import('@/pages/Accounts/vouchers/ClosingVoucher.vue'),
          meta: {
            pageTitle: 'closedVoucher',
            breadcrumb: [
              { text: 'accounts', active: true },
              { text: 'vouchers', active: true },
            ],
            permission: 'addVouchers',
          },
        },
        {
          path: 'edit/:id',
          name: 'vouchers-edit',
          props: true,
          component: () => import('@/pages/Accounts/vouchers/Edit.vue'),
          meta: {
            pageTitle: 'vouchersEdit',
            breadcrumb: [
              { text: 'accounts', active: true },
              { text: 'vouchers', active: true },
            ],
            permission: 'editVouchers',
          },
        },
        {
          path: 'closedVoucherEdit/:id',
          name: 'closedVoucher-edit',
          props: true,
          component: () => import('@/pages/Accounts/vouchers/ClosingVoucher.vue'),
          meta: {
            pageTitle: 'closedVoucher',
            breadcrumb: [
              { text: 'accounts', active: true },
              { text: 'vouchers', active: true },
            ],
            permission: 'editVouchers',
          },
        },
      ],
    },
    {
      path: '/addition-order',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: 'new',
          name: 'addition-order-new',
          component: () => import('@/pages/Stores/AdditionOrder/Edit.vue'),
          meta: {
            pageTitle: 'newAdditionOrder',
            breadcrumb: [{ text: 'additionOrder', active: true }],
            permission: 'viewAdditionOrders',
          },
        },
        {
          path: 'edit/:id',
          name: 'addition-order-edit',
          props: true,
          component: () => import('@/pages/Stores/AdditionOrder/Edit.vue'),
          meta: {
            pageTitle: 'editAdditionOrder',
            breadcrumb: [{ text: 'additionOrder', active: true }],
            permission: 'editAdditionOrders',
          },
        },
      ],
    },
    {
      path: '/manufacturing-order',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: 'new',
          name: 'manufacturing-order-new',
          component: () => import('@/pages/Stores/Manufacturing/Edit.vue'),
          meta: {
            pageTitle: 'newManufacturingOrder',
            breadcrumb: [{ text: 'manufacturingOrder', active: true }],
            permission: 'viewManufacturingOrders',
          },
        },
        {
          path: 'edit/:id',
          name: 'manufacturing-order-edit',
          props: true,
          component: () => import('@/pages/Stores/Manufacturing/Edit.vue'),
          meta: {
            pageTitle: 'editManufacturingOrder',
            breadcrumb: [{ text: 'manufacturingOrder', active: true }],
            permission: 'editManufacturingOrders',
          },
        },
      ],
    },
    {
      path: '/view/:id',
      name: 'manufacturingExchangeOrder',
      props: true,
      component: () => import('@/pages/Stores/ManufacturingExchangeOrder/Edit.vue'),
      meta: {
        pageTitle: 'manufacturingExchangeOrder',
        breadcrumb: [{ text: 'manufacturingExchangeOrder', active: true }],
        permission: 'editManufacturingOrders',
      },
    },
    {
      path: '/inventory',
      component: () => import('@/layouts/navigationIndex.vue'),
      children: [
        {
          path: '',
          name: 'inventory',
          component: () => import('@/pages/Stores/Inventory/List.vue'),
          meta: {
            pageTitle: 'inventory',
            breadcrumb: [{ text: 'inventory-wharehous', active: true }],
            permission: 'viewStocktaking',
          },
        },
        {
          path: 'new',
          name: 'inventory-new',
          component: () => import('@/pages/Stores/Inventory/Edit.vue'),
          meta: {
            pageTitle: 'inventoryNew',
            breadcrumb: [
              { text: 'inventory-wharehous', active: true },
              { text: 'inventory', active: true },
            ],
            permission: 'addStocktaking',
          },
        },
        {
          path: 'edit/:id',
          name: 'inventory-edit',
          props: true,
          component: () => import('@/pages/Stores/Inventory/Edit.vue'),
          meta: {
            pageTitle: 'inventoryEdit',
            breadcrumb: [
              { text: 'inventory-wharehous', active: true },
              { text: 'inventory', active: true },
            ],
            permission: 'editStocktaking',
          },
        },
      ],
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('@/pages/Settings/ChangePassword/Edit.vue'),
      meta: {
        pageTitle: 'changePassword',
        breadcrumb: [{ text: 'changePassword', active: true }],
        permission: '',
      },
    },
    {
      path: '/accounts-reports',
      name: 'accounts-reports',
      component: () => import('@/pages/Settings/Report/accountsReports.vue'),
      meta: {
        pageTitle: 'accounts-reports',
        breadcrumb: [
          {
            text: 'reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sales-reports',
      name: 'sales-reports',
      component: () => import('@/pages/Settings/Report/salesReports.vue'),
      meta: {
        pageTitle: 'sales-reports',
        breadcrumb: [
          {
            text: 'reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/purchase-reports',
      name: 'purchase-reports',
      component: () => import('@/pages/Settings/Report/purchaseReports.vue'),
      meta: {
        pageTitle: 'purchase-reports',
        breadcrumb: [
          {
            text: 'reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/customers-and-suppliers',
      name: 'customers-and-suppliers',
      component: () => import('@/pages/Settings/Report/CustomersAndSuppliersReport.vue'),
      meta: {
        pageTitle: 'customers-and-suppliers',
        breadcrumb: [
          {
            text: 'reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/concrete-reports',
      name: 'concrete-reports',
      component: () => import('@/pages/Settings/Report/ConcreteReport.vue'),
      meta: {
        pageTitle: 'concrete-reports',
        breadcrumb: [
          {
            text: 'reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/items-reports',
      name: 'items-reports',
      component: () => import('@/pages/Settings/Report/itemsReports.vue'),
      meta: {
        pageTitle: 'items-reports',
        breadcrumb: [
          {
            text: 'reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/logs',
      name: 'logs',
      component: () => import('@/pages/Settings/Logs/List.vue'),
      beforeEnter: (to, from, next) => next({ name: '@/pages/Dashboard/UsersAndAgentsDashboard.vue' }), 
      meta: {
        pageTitle: 'logs',
        breadcrumb: [{ text: 'logs', active: true }],
        permission: '',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/UserAccount/Login.vue'),
      meta: { layout: 'full' },
    },
    {
      path: '/shareInvoice/:id?',
      name: 'shareInvoice',
      component: () => import('@/pages/UserAccount/SmsView.vue'),
      meta: { layout: 'full' },
    },
    {
      path: '/SmartMenu/:id?',
      name: 'SmartMenu',
      component: () => import('@/pages/Sales/SmartMenu/Edit.vue'),
      meta: { layout: 'full' },
    },
    {
      path: '/ForgetPassword',
      name: 'forget-password',
      component: () => import('@/pages/UserAccount/ForgotPassword.vue'),
      meta: { layout: 'full' },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: { layout: 'full' },
    },
    { path: '*', redirect: 'error-404' },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();

  // Redirect to login if not logged in
  if (!isLoggedIn && to.name !== 'login' && to.name !== 'shareInvoice' && to.name !== 'SmartMenu' && to.name !== 'forget-password') return next({ name: 'login' });

  if (!canNavigate(to)) {
    // If logged in => not authorized
    return next({ name: 'error-404' });
  }

  if (HASBA_HIDDEN_ROUTES.includes(to.name) && getUserData().isHesbaClient) {
    return next({ name: 'home' });
  }

  // Clear idempotency key on route change
  sessionStorage.removeItem('current-idempotency-key');

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Keep splash until Hasba CSS is ready (set in main.js boot)
  if (window.__HASBA_BOOTING__) return;

  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
